import React from "react";

const SectionName = ({name}) => {
    return (  
        <span className={"section__name"}>{name}</span>
    )
}

export default SectionName